import "./Separator.scss";

import { LogoHorse } from "../../assets/svg/svgIcons";

const Separator = () => {
  return (
    <div className="separator">
      <div className="separatorLine left"></div>
      <LogoHorse className="separatorIcon" />
      <div className="separatorLine right"></div>
    </div>
  );
};

export default Separator;
